module.exports = __webpack_public_path__ + "img/secure-payment.4b01a325.png";